import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const InfoCellRenderer: React.FC<ICellRendererParams> = params => {
  return (
    <span className="flex items-center justify-center w-[20px] h-[20px] rounded-[5px] border border-gray-400 bg-white mx-auto mt-2 text-black cursor-pointer">
      i
    </span>
  );
};

export default InfoCellRenderer;
